// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1ZegX","col":"Table_col__3gLhO","fulfillmentStatus":"Table_fulfillmentStatus__3eWCT","emailCol":"Table_emailCol__2lCzV"};